var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hm-chip",style:({backgroundColor: _vm.isMeal ? `rgb(from ${_vm.color} r g b / 0.12)` : '#F6F6F6'})},[_c('span',{staticClass:"hm-chip__text",class:{'hm-chip__text--meal': _vm.isMeal},style:({color: _vm.color})},[_vm._t("default")],2),_vm._t("icon")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }